export default __webpack_public_path__ + "static/media/atp_logo_white.c36644a2.png";